import { assign } from '@ember/polyfills';

export default Object.assign || assign;
